import { Stack, Typography } from '@mui/material';

export const RefundPolicy = () => {
    return (
        <Stack direction='column' spacing={2} sx={{ width: '90%', maxWidth: '1280px', margin: '0 auto', paddingTop: '20px', paddingBottom: '30px' }}>
        <Typography variant='h6' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            Online payments – refund policy
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            We are committed to providing our customers with a high level of service.
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            Our refund policy applies to online services purchased from our website: <a href='https://picagroup.com.au/' target='_blank' rel='noopener noreferrer'>https://picagroup.com.au</a>
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            If you are not satisfied with a service we have provided, please contact our customer support team on the details below so that we can find a solution for you.
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            To request a refund, please email within two days from the date of purchase.
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            To be eligible for a refund you must provide a valid reason for your request and proof of purchase. Once we receive your email, we will consider your request and determine if a refund will be provided. Each request will be assessed based on its own merits.
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            We reserve the right to:
        </Typography>
        <ul>
            <li>
                <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
                    refuse a refund if we determine that your request is not valid; and
                </Typography>
            </li>
            <li>
                <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
                    retain service fees where you change your mind after we have processed your order.
                </Typography>
            </li>
        </ul>

        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            Refunds will be issued to the original payment method used for the purchase. Please allow for five to ten business days for the refund to appear in your account.
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            We reserve the right to modify or update this refund policy at any time to take into account changes in applicable laws and business practices. Any changes to the policy will be posted on our website and will be effective immediately. Any refund requests made on or after the date of amendment will be assessed under the updated policy.
        </Typography>
        <Typography variant='body1' align='left' color='primary' sx={{ width: '100%', margin: '0 auto' }} gutterBottom>
            If you have any questions or concerns about our refund policy or status of a refund request, please contact our customer support team at <a href='mailto:searches@picagroup.com.au'>searches@picagroup.com.au</a>
        </Typography>
    </Stack>
    );
};